module.exports = __webpack_public_path__ + "img/jieshao.ece0bcfb.jpg";